import { useEffect } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { ProductSection } from '../components/landing/ProductSection';
import { OfferSection } from '../components/landing/OfferSection';
import { initMetaPixel } from '../utils/pixel';

export default function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);

  return (
    <main className="font-body min-h-screen">
      <HeroSection />
      <ProblemSection />
      <ProductSection />
      <OfferSection />
    </main>
  );
}
